const getUser = (state) => state.user

const obj = { getUser }

export default obj
